import {
	DEC_CUTLERY,
	INC_CUTLERY,
	PLACE_ORDER,
	SET_ORDER_COMMENT,
	SET_PAYMENT_TYPE,
	SET_TIP_PERCENT,
	SET_USE_CASH_POINTS,
} from 'new-constants/purchase.constants';
import {PaymentTypes} from 'new-constants/common.constants';
import {
	CARD_PAYMENT_CONFIRMATION_POPUP,
	PICKUP_CONFIRMATION_POPUP,
} from 'new-components/popups/confirmation/Confirmation';
import {CUSTOM_PAYMENT_TYPE_CONFIRMATION_POPUP} from "../components/popups/confirmation/Confirmation";
import {TABLE_EDIT_POPUP} from "../components/popups/table-edit/TableEdit";
import {trackEvent} from "../helpers/tracking.helpers";

export const setOrderComment = (restaurantId, comment) => {
	trackEvent({
		event: 'Set Order Comment',
		properties: {
			'Venue Id': restaurantId,
		}
	});
	return {
		type: SET_ORDER_COMMENT,
		restaurantId,
		comment,
	};
};

export const setTipPercent = (restaurantId, percent) => {
	trackEvent({
		event: 'Set Tip Percentage', properties: {
			'Tip Percentage': percent,
			'Venue Id': restaurantId,
		}
	});
	return {
		type: SET_TIP_PERCENT,
		restaurantId,
		percent,
	};
};

export const setPaymentType = (restaurantId, paymentType, subPaymentType) => {
	trackEvent({
		event: 'Set Payment Type', properties: {
			'Venue Id': restaurantId,
			'Payment Type': Object.keys(PaymentTypes).find(key => PaymentTypes[key] === paymentType),
		}
	});
	return {
		type: SET_PAYMENT_TYPE,
		restaurantId,
		paymentType,
		subPaymentType
	};
};

export const setUseCashPoints = (restaurantId, useCashPoints) => {
	trackEvent({
		event: 'Set Use Cashpoints', properties: {
			'Venue Id': restaurantId,
			'Use Cash Points': useCashPoints,
		}
	});
	return {
		type: SET_USE_CASH_POINTS,
		restaurantId,
		useCashPoints,
	};
};

export const placeOrder = (guestOrder, paymentType, currentCardNumber, isTableNotSelected, currentRestaurantId) => {
	const pickupWarning = paymentType === PaymentTypes.payAtPickup ? PICKUP_CONFIRMATION_POPUP : null;
	const cardPaymentWarning = currentCardNumber && paymentType === PaymentTypes.payWithStripe ? CARD_PAYMENT_CONFIRMATION_POPUP : null;
	const customPaymentTypeWarning = paymentType === PaymentTypes.customPaymentType ? CUSTOM_PAYMENT_TYPE_CONFIRMATION_POPUP : null;
	const tableEditPopup = isTableNotSelected ? TABLE_EDIT_POPUP : null;

	trackEvent({
		event: 'Place Order Request', properties: {
			'Venue Id': currentRestaurantId,
			'Payment Type': paymentType,
			'Table Selected': !isTableNotSelected
		}
	});

	return {
		type: PLACE_ORDER,
		showPopup: (tableEditPopup || pickupWarning || cardPaymentWarning || customPaymentTypeWarning),
		paymentType,
	};
};

export const incCutlery = restaurantId => {
	trackEvent({
		event: 'Increase Cutlery', properties: {
			'Venue Id': restaurantId,
		}
	});
	return {
		type: INC_CUTLERY,
		restaurantId,
	};
};

export const decCutlery = restaurantId => {
	trackEvent({
		event: 'Decrease Cutlery', properties: {
			'Venue Id': restaurantId,
		}
	});
	return {
		type: DEC_CUTLERY,
		restaurantId,
	};
};
